export default __webpack_public_path__ + "static/media/Frame 189.79e0e1c6.svg";